import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { OrderEntity } from './order.entity';

@Index('_fk__file__id', ['fkFileId'], {})
@Index('_fk_order__id', ['fkOrderId'], {})
@Entity('order__file')
export class OrderFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_order__id', unsigned: true })
	public fkOrderId!: number;

	@ManyToOne(() => FileEntity, (file) => file.orderFiles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;

	@ManyToOne(() => OrderEntity, (order) => order.orderFiles, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk_order__id', referencedColumnName: 'id' }])
	public fkOrder!: OrderEntity;
}
